import { DELIVERY_OPTION_KNOWLEDGE_BASE_URLS } from '@/constants/knowledgeBaseUrls';
import { Logger } from '@/utils/logger';
import type { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import { Alert, Link, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';

const logger = new Logger('ShippingOptionAlertPresence');

export const ShippingOptionAlertPresence = ({
  deliveryOptionName,
}: {
  deliveryOptionName: (typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'];
}) => {
  const helpLink = DELIVERY_OPTION_KNOWLEDGE_BASE_URLS[deliveryOptionName];

  useEffect(() => {
    if (!helpLink) {
      logger.critical('missing helpLink', {
        deliveryOptionName,
      });
    }
  }, [deliveryOptionName, helpLink]);

  return (
    <Alert severity="warning" data-testid="shippingOptionAlertPresence">
      <Typography variant="body2">
        You must receive the order in-person.{' '}
        <Link id="shipping_presence_banner_help_link" href={helpLink} target="_blank" rel="noopener noreferrer">
          Learn more
        </Link>
      </Typography>
    </Alert>
  );
};
